import {GenericList} from './GenericList';
import {Category} from '../../models/Category';

export class CategoryList extends GenericList<Category> {}
